import type { HTMLAttributes, ReactElement } from 'react';
import { buildComponentMeta, useComponentMeta } from '../../ui';
import { adminMeta } from './componentMeta';

export function ComponentRegistry({ id, children, ...props }: HTMLAttributes<HTMLDivElement> & { id: string }): ReactElement {
  const meta = buildComponentMeta(adminMeta(id));
  const ref = useComponentMeta<HTMLDivElement>(meta);
  return <div {...props} ref={ref} data-ui-id={id} data-ui-role={meta.role}>{children}</div>;
}
